import { ChartOfAccount } from "./chart-of-account";
import { Contact } from "./contact";
import { SystemField } from "./system-field";

export class PersonAccount  extends SystemField{
     
    phone?: string;
    email?: string;
    commune?: string;
    district?: string;
    city?: string;
    postalcode?: string;
    country?: string;
    billing_commune?: string;
    billing_district?: string;
    billing_city?: string;
    billing_postalcode?: string;
    billing_country?: string;
    person_type?: string; 
    person_code?: string;
    users_id?: string;
    photo?: string;
    is_active?: number;
    birthday?: string;
    gender?: string;
    date_hired?: string;
    date_leave?: string;
    facebook?: string;
    twitter?: string;
    pinterest?: string;
    google_plus?: string;
    mobile?: string;
    other_phone?: string;
    linkedin?: string;
    title?: string;
    marital_status?: string;
    nationality?: string;
    ethnicity?: string;
    religion?: string;
    birth_commune?: string;
    birth_district?: string;
    birth_city?: string;
    birth_country?: string;
    status?: string;
    home_phone?: string;
    partner_company_id?: string;
    register_date?: string;
    height?: string;
    house_num?: string;
    couple_divided?: string;
    count_son?: string;
    count_daughter?: string;
    birth_house_num?: string;
    is_alive?: string;
    birth_village?: string;
    village?: string;
    fax?: string;
    website?: string;
    ordering?: string;
    show_on_footer?: string;
    record_type?:string;
    is_default?:number;
    company_id?:string;
    lat?:number;
    log?:number;
    personal_coa_id?:string;
    discount_coa_id?:string;
	prepayment_coa_id?:string;
	retainage_coa_id?:string;



    // Formula Fields
    photo_file?:File;
    photo_preview?: string;

    // Import class translate
    langs?: any;
    contact?:Contact[];
    chart_of_account?:ChartOfAccount;

}


export class PersonAccountTranslation  extends SystemField{
    lastname?: string;
    firstname?: string;
    nickname?: string;
    address_line?: string;
    billing_address_line?: string;
    lang_code?: string;
    short_description?:string;
    person_account_id?: string;
    birth_address?: string;
    note?: string;
    occupation?: string;
    experience?: string;
    knowledge?: string;
    culture_lvl?: string;
    training_lvl?: string;
}
